{
  "schemaVersion": 1,
  "id": "oak-board-70",
  "version": "1.0",
  "kind": "board",
  "species": "Oak",
  "material": "Solid oak",
  "nominalDescription": "Solid oak 70 mm, face-laminated from two 35 mm boards, planed all round, oiled",
  "edgeDescription": "Solid oak, planed, 1 mm arris",
  "thicknessTicks": 700,
  "nominalThicknessTicks": 700,
  "maxWidthTicks": 1800,
  "maxLengthTicks": 25000,
  "grainAxis": "length",
  "finishSpec": "Hard-wax oil, two coats",
  "density": 720,
  "back": {
    "description": "Oak-veneered plywood 6 mm, B/BB",
    "thicknessTicks": 60,
    "nominalThicknessTicks": 60,
    "sheet": {
      "lengthTicks": 24400,
      "widthTicks": 12200
    },
    "grainAxis": "length",
    "allowRotation": false
  },
  "notes": "Self-authored chunky slab stock (pilot-v1-r3 p14: slabs reading about 70 mm): two 35 mm oak boards face-laminated and planed to 70 mm, in the same widths as the oak-board-45 profile; wider parts are edge-glued from strips by the same rule (plan §5). Back and finish as oak-board-45."
}
